import { render, staticRenderFns } from "./Details.vue.js?vue&type=template&id=2bff9bb0&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Details.vue?vue&type=template&id=2bff9bb0&scoped=true"
import script from "./Details.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue.scss?vue&type=style&index=0&id=2bff9bb0&prod&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Details.vue?vue&type=style&index=0&id=2bff9bb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bff9bb0",
  null
  
)

export default component.exports